import { render, staticRenderFns } from "./WaitingActivate.vue?vue&type=template&id=240715e4&scoped=true&"
import script from "./WaitingActivate.vue?vue&type=script&lang=js&"
export * from "./WaitingActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240715e4",
  null
  
)

export default component.exports